var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8 14.8913C8 15.4413 7.55 15.8913 7 15.8913H1C0.45 15.8913 0 15.4413 0 14.8913C0 14.3413 0.45 13.8913 1 13.8913H7C7.55 13.8913 8 14.3413 8 14.8913ZM3 3.88131V10.8913C3 11.4413 3.45 11.8913 4 11.8913C4.55 11.8913 5 11.4413 5 10.8913V3.88131H6.79C7.24 3.88131 7.46 3.34131 7.14 3.03131L4.35 0.251313C4.25449 0.159758 4.1273 0.108643 3.995 0.108643C3.8627 0.108643 3.73551 0.159758 3.64 0.251313L0.86 3.03131C0.54 3.34131 0.76 3.88131 1.21 3.88131H3Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.7bcdf5b5ba7a95d807857f7bb0f296d1.svg";
export { ForwardRef as ReactComponent };